<template>
    <div class="ProductListWrap">
        <div class="SwiperWrap">
            <i class="LeftShadow"><img src="../../assets/Home/LeftShadow.png"></i>
            <swiper class="SwiperList" ref="mySwiper" :options="swiperOptions">
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img2.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img9.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img3.jpg"></swiper-slide>
                <div class="swiper-pagination flex" slot="pagination"></div>
            </swiper>
            <i class="RightShadow"><img src="../../assets/Home/RightShadow.png"></i>
        </div>
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>GOEASY <span>COOPERATION </span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div class="ListWrap">
<!--            <div class="Title">
                <p>当代艺术品/手工艺品/古董</p>
            </div>-->
            <ul>
                <!-- 有多个 -->
                <li>
                    <div class="Product flexa">
                       <i><img src="../../assets/Home/product1.jpg"></i>
                        <div class="Text">
                            <p>中国艺品网</p>
                            <p>艺品网是中国工艺美术协会打造的工艺美术行业全产业链服务平台，通过整合行业优势资源，推动行业的转型升级，艺品网是工艺美术行业的互联网+转型服务平台。艺品网旨在弘扬中国手工艺文化，实现行业创新，分享互联网价值；通过“一品一码”和“真人、真品、真店”打造诚信保真体系。</p>
                        </div>
                        <div @click="OpenUrl('http://www.craftschina.cn/')" class="Button flex"><p>查看</p></div>
                     </div>
                </li>
                <li>
                    <div class="Product flexa">
                        <i><img src="../../assets/Home/list8.jpg"></i>
                        <div class="Text">
                            <p>谷成农链</p>
                            <p>谷成农链是国内首家真正做到以种植户为核心，并结合金融赋能打通产业链的种植业供应链金融服务平台服务。谷成农链通过整合资源、创新平台、组建基层组织三个体系，实现标准化、数字化、协同化服务平台。</p>
                        </div>
                        <div  @click="OpenUrl('http://www.guchengac.com/')" class="Button flex"><p>查看</p></div>
                    </div>
                </li>
                <li>
                    <div class="Product flexa">
                        <i><img src="../../assets/Home/list21.jpg"></i>
                        <div class="Text">
                            <p>黄金假日旅行网</p>
                            <p>GHD Group(黄金假日旅行网)是一家专注于深度自由行(DFIT)、商务出行(TMC)、高端定制旅行(CCT)的全球性出境服务集团。创立于1993年，总部设在中国北京，并在纽约、香港、上海、深圳等一线城市设有分公司及办事处。公司以“让旅行更简单”为导向，以“四省二保”（省钱、省时、省心、省事、保证出行及旅行保障）为服务宗旨，专注为旅客提供安心、省心、贴心的“三心”旅行服务。</p>
                        </div>
                        <div @click="OpenUrl('http://www.91ghd.com/')" class="Button flex"><p>查看</p></div>
                    </div>
                </li>
                <li>
                    <div class="Product flexa">
                        <i><img src="../../assets/Home/list10.jpg"></i>
                        <div class="Text">
                            <p>工易云医疗</p>
                            <p>工易云医疗以医疗机构的设备管理为核心，下游打通经销商、服务商、生产厂家的采购管理、库存管理、销售管理、往来管理，甚至财务管理、费用报销、基础HR管理等业务。主要功能包括：财务总账（包括财务的报表）、费用报销管理、往来管理（包括应收、应付和往来结算）、采购管理、库存管理、销售管理、基础人事管理、薪酬管理等。</p>
                        </div>
                        <div class="Button flex hidden"><p>查看</p></div>
                    </div>
                </li>
                <li>
                    <div class="Product flexa">
                        <i><img src="../../assets/Home/list22.jpg"></i>
                        <div class="Text">
                            <p>小店快修</p>
                            <p>小店快修以"帮助实体门店减少后顾之忧"为经营目标，秉承"透明、高效、平价"的服务理念，依托移动互联网提供实体门店的维修和维护服务。经过多年积累，小店快修整合了大量专业工人，建立了规范化的服务流程，为实体门店提供全年365天快速响应服务。</p>
                        </div>
                        <div class="Button flex hidden"><p>查看</p></div>
                    </div>
                </li>
                <li>
                    <div class="Product flexa">
                        <i><img src="../../assets/Home/list9.jpg"></i>
                        <div class="Text">
                            <p>再下一单</p>
                            <p><!--德农种业股份公司是专注于种子，集科研、生产、经营、服务于一体的现代大型综合高新技术种子企业。公司成立于2002年10月，注册资本1.86亿元，专营玉米杂交种子。--></p>
                        </div>
                        <div class="Button flex hidden"><p>查看</p></div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'productlist',
    components: {},
    data() {
      return {
        swiperOptions: {
          slidesPerView: 1.15,
          centeredSlides: true,
          spaceBetween: 15,
          initialSlide: 1,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination'
          }
        }
      };
    },
    methods: {
      Return() {
        this.$router.back();
      },
      OpenUrl(url) {
        window.open(url, '_blank');
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .ProductListWrap{
        width: 100%;
        .ListWrap{
            width: 90%;
            margin: 0.15rem auto 0.05rem;
            .Title{
                width: 100%;
                border-bottom: 1px solid #666666;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    opacity: 0.6;
                    padding-bottom: 0.05rem;
                }
            }
            ul{
                li{
                    width: 100%;
                    margin-bottom: 0.1rem;
                    position: relative;
                    .Product{
                        margin-top: 0.05rem;
                        border-radius: 0.1rem;
                        background: linear-gradient(to Right,#666666,#3b3b3b);
                        padding: 0.15rem 0.1rem;
                        box-sizing: border-box;
                        .Button{
                            position: absolute;
                            bottom: 0.08rem;
                            right: 0.08rem;
                            background-color: #8c73b5;
                            width: 0.3rem;
                            height: 0.12rem;
                            cursor: pointer;
                            border-radius: 0.3rem;
                            p{
                                color: #fff;
                                font-size: $AdditionTextSize;
                            }
                        }
                        .Text{
                            width: 2.25rem;
                            height: 0.5rem;
                            margin-left: 0.05rem;
                            p:first-child{
                                font-size: $TextSize;
                                font-weight: bold;
                                margin-bottom: 0.09rem;
                                margin-top: 0.04rem;
                                color: #fff;
                            }
                            p:last-child{
                                font-size: $AdditionTextSize;
                                color: #fff;
                                line-height: 0.075rem;
                            }
                        }
                        i{
                            width: 0.5rem;
                            height: 0.5rem;
                            img{
                                width: 100%;
                                height: 100%;
                                border-radius: 0.115rem;
                                object-fit: cover;
                            }
                        }
                    }
                }
            }
        }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .SwiperWrap {
            width: 100%;
            height: 1.3rem;
            position: relative;
            overflow: hidden;
            .swiper-pagination {
                width: 100%;
                height: 0.1rem;
                position: absolute;
                bottom: 0.02rem;
                ::v-deep .swiper-pagination-bullet-active {
                    background-color: #fff !important;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 0.15rem;
                    height: 0.02rem;
                    opacity: 1;
                    margin: 0 0.02rem;
                    background-color: #4d4d4d;
                    border-radius: 0.03rem;
                }
            }

            .LeftShadow, .RightShadow {
                height: 100%;
                position: absolute;
                z-index: 2;

                img {
                    height: 100%;
                    transform: scale(1.1);
                }
            }

            .LeftShadow {
                left: -0.1rem;
                top: 0;
            }

            .RightShadow {
                right: -0.1rem;
                top: 0;
            }

            .SwiperList {
                width: 100%;
                height: 100%;

                .ImgWrap {
                    border-radius: 0.1rem;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 0.1rem;
                    }
                }
            }
        }
    }
</style>
